import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import HoverableTooltip from "components/UI/Tooltip/HoverableTooltip";
import { UpOutlined, DownOutlined } from "@ant-design/icons";

import "./GenericCard.scss";

const GenericCard = (props) => {
  const {
    children,
    title,
    className = "",
    isCardOpenByDefault = true,
    tooltipText,
    noPaddingTop,
    maxHeight = 600,
    minHeight = 184,
    onCardOpen,
    disableToggle = false,
  } = props;
  const [isCardOpen, setCardIsOpen] = useState(isCardOpenByDefault);
  const [hasCardOpened, setHasCardOpened] = useState(false);

  const onToggleCard = () => {
    if (!disableToggle) {
      setCardIsOpen((prevState) => !prevState);
    }
  };

  useEffect(() => {
    if (isCardOpen && onCardOpen && !hasCardOpened) {
      setHasCardOpened(true);
      onCardOpen();
    }
  }, [isCardOpen, onCardOpen, hasCardOpened]);

  // If toggle is disabled, always show content
  const shouldShowContent = disableToggle || isCardOpen;

  return (
    <div
      className={`generic-card-wrapper ${className} ${
        !disableToggle && !isCardOpen ? "card-closed" : ""
      }`}
    >
      {title && (
        <div
          className={`card-header ${disableToggle ? "no-toggle" : ""}`}
          onClick={onToggleCard}
        >
          <div className="card-title">
            {tooltipText && <HoverableTooltip text={tooltipText} />}
            <h4 className="text-[1rem] font-medium">{title}</h4>
          </div>
          {!disableToggle && (isCardOpen ? <UpOutlined /> : <DownOutlined />)}
        </div>
      )}
      {shouldShowContent && (
        <div
          className="content"
          style={{
            maxHeight,
            minHeight,
            paddingTop: noPaddingTop ? 0 : undefined,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

GenericCard.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  className: PropTypes.string,
  isCardOpenByDefault: PropTypes.bool,
  tooltipText: PropTypes.string,
  maxHeight: PropTypes.number,
  noPaddingTop: PropTypes.bool,
  onCardOpen: PropTypes.func,
  disableToggle: PropTypes.bool,
};

export default GenericCard;
